export const commonApiConsts = {
    API_NAME: "common-api", // This name needs to be the same as the name of the API in the App.tsx file
}
